import { SR_API_ACTION_GET_MARKET_BY_ID } from 'api/actionTypes';

export default async function getById({ state, apiClient }, { marketId }) {
  if (!marketId) {
    return null;
  }
  const marketIdPath = ['markets', 'byId', marketId];
  if (state.get(marketIdPath)) {
    return state.get(marketIdPath);
  }

  let market;
  await apiClient.postWithState({
    action: SR_API_ACTION_GET_MARKET_BY_ID,
    state: state,
    payload: {
      marketId,
    },
    onSuccess(loadedMarket) {
      state.set(marketIdPath, loadedMarket);
      market = loadedMarket;
    },
  });

  return market;
}
